import assetActionTypeService from "../../../../services/assetService/assetActionService/assetActionTypeService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_ASSETACTIONTYPES } from "../../../../utils/constants";
import { AssetActionTypeInterface } from "../../../../models/AssetModel/AssetAction/AssetActionType";

interface AddAssetActionTypesContext {
  previousAssetActionTypes: AssetActionTypeInterface[];
}

const useAddAssetActionType = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    AssetActionTypeInterface,
    Error,
    AssetActionTypeInterface,
    AddAssetActionTypesContext
  >({
    mutationFn: assetActionTypeService.Save,

    onMutate: () => {
      const previousAssetActionTypes =
        queryClient.getQueryData<AssetActionTypeInterface[]>([
          CACHE_KEY_ASSETACTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ]) || [];

      return { previousAssetActionTypes };
    },

    onSuccess: (savedAssetActionType) => {
      queryClient.setQueryData<AssetActionTypeInterface[]>(
        [
          CACHE_KEY_ASSETACTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        (assetActionTypes) =>
          assetActionTypes
            ? [savedAssetActionType, ...assetActionTypes]
            : [savedAssetActionType]
      );
    },

    onError: (error, newAssetActionType, context) => {
      if (!context) return;

      queryClient.setQueryData<AssetActionTypeInterface[]>(
        [
          CACHE_KEY_ASSETACTIONTYPES,
          page > 0 ? page : null,
          pageSize > 0 ? pageSize : null,
        ],
        context.previousAssetActionTypes
      );
    },
  });
};

export default useAddAssetActionType;
